import { type BirthDateType } from 'ui/Form/BirthDateInput';

// TODO not sure if this is even needed
export const isDateOfBirthValid = (value?: Partial<BirthDateType>): boolean => {
  return Boolean(value?.date);
};
